import { render, staticRenderFns } from "./ConfigurationWorkDaysModal.vue?vue&type=template&id=5422dc11&"
import script from "./ConfigurationWorkDaysModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWorkDaysModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWorkDaysModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports